import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BrapiSyncContextService } from '../brapi-sync-context.service';
import { HttpClient, HttpContext } from '@angular/common/http';
import { EntityEnum, ExternalReferenceService } from '../shared/external-reference/external-reference.service';
import { EXTERNAL_REFERENCE_SOURCE } from '../app.constants';
import { AlertService } from '../../shared/alert/alert.service';
import { BrapiSyncPath, BrapiSyncService } from '../brapi-sync.service';
import { handleStatusMessages, toText } from '../util/brapi-all';
import { EnableSavingIndicator } from '../../shared/loading-indicator';

declare const BrAPI: any;

@Component({
    selector: 'app-trial',
    templateUrl: './trial.component.html',
    styleUrls: ['./trial.component.css']
})
export class TrialComponent implements OnInit {

    loading = false;
    trialAlreadyExists: boolean = false;
    trialSaved: boolean = false;

    brapiDestination: any;

    constructor(private router: Router,
              private http: HttpClient,
              private externalReferenceService: ExternalReferenceService,
              public context: BrapiSyncContextService,
              private alertService: AlertService,
                private brapiSyncService: BrapiSyncService) {
        this.brapiDestination = BrAPI(this.context.destination, '2.0', this.context.destinationToken);
    }

    ngOnInit(): void {
        this.alertService.closeAllAlerts();
        this.checkTrialAlreadyExists();
    }

    async next(): Promise<void> {
        this.brapiSyncService.navigateToPage(BrapiSyncPath.Study);
    }

    cancel(): void {
        this.brapiSyncService.navigateToPage(BrapiSyncPath.EntitySelector);
    }

    onStudySelect(): void {
        this.reset();
        this.checkTrialAlreadyExists();
    }

    async post() {
        this.reset();
        this.loading = true;
        await this.http.post(this.context.destination + '/trials', [this.transform(this.context.sourceTrial)], { context: new HttpContext().set(EnableSavingIndicator, true) }).toPromise().then((response: any) => {
            if (response.metadata) {

                const { hasErrors } = handleStatusMessages(response.metadata.status, this.alertService);

                this.trialSaved = !hasErrors;
                if (response?.result?.data) {
                    this.context.targetTrial = response.result.data[0];
                }
            }
        });
        this.loading = false;
    }

    transform(trial: any) {
        return {
            active: trial.active,
            additionalInfo: trial.additionalInfo,
            contacts: trial.contacts,
            datasetAuthorships: trial.datasetAuthorships,
            documentationURL: trial.documentationURL,
            endDate: trial.endDate,
            externalReferences: this.externalReferenceService.generateExternalReference(trial.trialDbId, EntityEnum.TRIALS, trial.externalReferences),
            programDbId: this.context.targetProgram.programDbId,
            programName: this.context.targetProgram.programName,
            publications: trial.publications,
            startDate: trial.startDate,
            trialName: trial.trialName,
            trialDescription: trial.trialDescription,
            trialPUI: trial.trialPUI
        };
    }

    checkTrialAlreadyExists() {
    // Check if the trial to be imported already exists in the destination server
        if (this.context.sourceTrial && this.context.sourceTrial.trialDbId) {
            this.brapiDestination.trials({
                externalReferenceId: this.externalReferenceService.getReferenceId(EntityEnum.TRIALS, this.context.sourceTrial.trialDbId),
                externalReferenceSource: EXTERNAL_REFERENCE_SOURCE
            }).all((result: any) => {
                if (result.length) {
                    this.trialAlreadyExists = true;
                    this.alertService.warning('brapi-sync.trial.warning.already-exists', { param1: this.context.sourceTrial.trialName, param2: result[0].trialName, param3: result[0].trialDbId });
                }
            });
        }
    }

    isValid(): boolean {
        return this.context.sourceTrial.trialDbId && this.context.sourceStudy.studyDbId
      && !this.trialAlreadyExists && !this.trialSaved && !this.loading;
    }

    canProceed(): boolean {
        return !this.loading && (this.trialSaved || this.trialAlreadyExists);
    }

    reset() {
        this.loading = false;
        this.trialSaved = false;
        this.trialAlreadyExists = false;
    }

}

